import { vuexHandbook } from '@/store/composition/module/handbook'
import { USER_URL } from '@/api/usersApi'
import { getUserFullName } from '@/utils/user'

const state = () => ({
  users: []
})

const getters = {
  userList: state => {
    return state.users.map(user => ({
      ...user,
      name: getUserFullName(user)
    }))
  }
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions(),
  async GETUserList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      url: USER_URL,
      keyStateList: 'users',
      errorMsg: 'Не удалось загрузить список пользователей',
      query: {
        expand: 'profile,roles'
      },
      search
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
